import { render, staticRenderFns } from "./remoteDesktop.vue?vue&type=template&id=000f2360&scoped=true"
import script from "./remoteDesktop.vue?vue&type=script&lang=js"
export * from "./remoteDesktop.vue?vue&type=script&lang=js"
import style0 from "./remoteDesktop.vue?vue&type=style&index=0&id=000f2360&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f2360",
  null
  
)

export default component.exports